import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Dispatch } from 'redux';
import { RootState } from '../../../stores/store';

interface Props extends LocalizeContextProps, RouteComponentProps {
}

class VerifyEmailSuccess extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <Card color={'success text-white'}>
                <CardBody>
                    <CardTitle tag="h3">{t('verifyEmail.header.update')}</CardTitle>
                    <div>
                        <p>{t('verifyEmail.text.success')}</p>
                        <Link to={{ pathname: '/login', state: { from: this.props.location } }} >
                            {t('verifyEmail.link.backToLogin')}
                        </Link>
                    </div>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(VerifyEmailSuccess)));
